import { render, staticRenderFns } from "./addShoppersTask.vue?vue&type=template&id=3162dae1&scoped=true&"
import script from "./addShoppersTask.vue?vue&type=script&lang=js&"
export * from "./addShoppersTask.vue?vue&type=script&lang=js&"
import style0 from "./addShoppersTask.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addShoppersTask.vue?vue&type=style&index=1&id=3162dae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162dae1",
  null
  
)

component.options.__file = "addShoppersTask.vue"
export default component.exports